export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14ZM5 4.5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H5ZM12 7a.75.75 0 0 1 .75.75l.001 3.593h3.406a.75.75 0 1 1 0 1.5H12.75v3.407a.75.75 0 0 1-1.5 0v-3.407H7.656a.75.75 0 0 1 .001-1.5h3.594L11.25 7.75A.75.75 0 0 1 12 7Z"/>
</svg>
`;
